import React, { useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp < Math.floor(Date.now() / 1000);
  } catch {
    return true;
  }
};

const ProtectedAdminRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isValidSession, setIsValidSession] = useState(null);

  useEffect(() => {
    const adminStr = localStorage.getItem('collegeAdminUser'); // Updated key
    const token = localStorage.getItem('collegeAdminToken');  // Updated key

    let admin = null;
    try {
      admin = JSON.parse(adminStr || 'null');
      console.log('Parsed admin:', admin); // Debug log
    } catch (e) {
      console.error('Error parsing admin:', e);
      admin = null;
    }

    console.log('Token:', token); // Debug log
    if (!admin || !token || isTokenExpired(token)) {
      // Clear storage if invalid
      localStorage.removeItem('collegeAdminUser');
      localStorage.removeItem('collegeAdminToken');
      localStorage.removeItem('collegeAdminRole');
      localStorage.removeItem('id');
      setIsValidSession(false);
      return;
    }

    setIsValidSession(true);

    // Optional: auto logout when token expires
    const payload = JSON.parse(atob(token.split('.')[1]));
    const expiresInMs = (payload.exp * 1000) - Date.now();

    const logoutTimer = setTimeout(() => {
      alert('Session expired. Please login again.');
      localStorage.removeItem('collegeAdminUser');
      localStorage.removeItem('collegeAdminToken');
      localStorage.removeItem('collegeAdminRole');
      localStorage.removeItem('id');
      navigate('/admin-login', { replace: true });
    }, expiresInMs);

    return () => clearTimeout(logoutTimer);

  }, [navigate]);

  if (isValidSession === null) {
    return null; // Loading state
  }

  if (!isValidSession) {
    return <Navigate to="/admin-login" replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedAdminRoute;